<template>
  <section class="flex flex-col gap-4">
    <h2
      class="text-[#FF0000] font-helvetica text-[22px] font-black hover:underline"
    >
      <a
        href="http://advrider.com/index.php?threads/rally-navigator-create-rally-roadbooks-with-google-earth-and-gps.851881/"
      >
        Visit Our User Forum on ADVRider
      </a>
    </h2>
    <a
      href="http://advrider.com/index.php?threads/rally-navigator-create-rally-roadbooks-with-google-earth-and-gps.851881/"
    >
      <picture class="contents">
        <source srcset="/images/create-cross-country/adv_rider.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="856"
        height="120"
        src="/images/create-cross-country/adv_rider.png"
        class="flex m-auto"
        alt="ADVrider forum logo"
        />
      </picture>
    </a>
  </section>
</template>

<script>
export default {
  name: 'ADVRider',
};
</script>

<style scoped></style>
